// extracted by mini-css-extract-plugin
export var chevronIcon = "_9j-2";
export var teamName = "_9j-1";
export var teamSwitcherButton = "_9j-0";